import { usePrismicLabels } from "~/hooks/usePrismicLabel";

/** Account menu entries, shared by the My account sidebar and the mobile header drawer. */
export const useCustomerMenuTabs = () => {
  const { $pt } = usePrismicLabels();

  return [
    {
      name: $pt("profile_side_tab_overview_name"),
      link: "/customer",
    },
    {
      name: $pt("profile_side_tab_order_name"),
      link: "/customer/orders",
    },
    {
      name: $pt("profile_side_tab_invoice_name"),
      link: "/customer/invoices",
    },
    {
      name: $pt("profile_side_tab_details_name"),
      link: "/customer/profile",
    },
  ];
};
